import { nanoid } from "nanoid";
import List from "../components/list";
import ListItem from "../components/list-item";
import Modal from "../components/modal";
import {
  Button,
  Heading,
  IconWithText,
  Image,
  ImageWithText,
  ImageWithText2,
  ImageWithText3,
  LinkList,
  List as ListModel,
  PostContent,
  Table,
  Text,
  Video,
} from "../models/post";

export default function AddPostContentModal(props: {
  close: () => void;
  addContent: (c: PostContent, index: number) => void;
  index: number;
}) {
  const key = nanoid();
  const addHeading = () => {
    const heading: Heading = {
      text: "",
      alignment: "left",
      size: "1",
    };
    const type = "heading";

    props.addContent({ key, type, value: heading }, props.index);
  };
  const addText = () => {
    const text: Text = {
      text: "",
    };
    const type = "text";
    props.addContent({ key, type, value: text }, props.index);
  };
  const addImage = () => {
    const image: Image = {
      src: "https://via.placeholder.com/728x90.png?text=Klicke+zum+Bearbeiten",
      alt: "",
      info: "",
      link: "",
    };
    const type = "image";
    props.addContent({ key, type, value: image }, props.index);
  };
  const addList = () => {
    const list: ListModel = {
      items: [],
    };
    const type = "list";
    props.addContent({ key, type, value: list }, props.index);
  };
  const addListLink = () => {
    const list: LinkList = {
      items: [],
    };
    const type = "list_with_links";
    props.addContent({ key, type, value: list }, props.index);
  };
  const addIconWithText = () => {
    const iconWithText: IconWithText = {
      icon: "",
      text: "",
    };
    const type = "icon_with_text";
    props.addContent({ key, type, value: iconWithText }, props.index);
  };
  const addImageWithText = () => {
    const imageWithText: ImageWithText = {
      image: {
        src: "https://via.placeholder.com/1000x668.png?text=Klicke+zum+Bearbeiten",
        alt: "",
        info: "",
        link: "",
      },
      text: "",
      alignment: "left",
    };
    const type = "image_with_text";
    props.addContent({ key, type, value: imageWithText }, props.index);
  };
  const addImageWithText2 = () => {
    const imageWithText2: ImageWithText2 = {
      image1: {
        src: "https://via.placeholder.com/1000x1000.png?text=Klicke+zum+Bearbeiten",
        alt: "",
        info: "",
        link: "",
      },
      image2: {
        src: "https://via.placeholder.com/1000x1000.png?text=Klicke+zum+Bearbeiten",
        alt: "",
        info: "",
        link: "",
      },
      text1: "",
      text2: "",
    };
    const type = "image_with_text_2";
    props.addContent({ key, type, value: imageWithText2 }, props.index);
  };
  const addImageWithText3 = () => {
    const imageWithText3: ImageWithText3 = {
      image1: {
        src: "https://via.placeholder.com/1000x1000.png?text=Klicke+zum+Bearbeiten",
        alt: "",
        info: "",
        link: "",
      },
      image2: {
        src: "https://via.placeholder.com/1000x1000.png?text=Klicke+zum+Bearbeiten",
        alt: "",
        info: "",
        link: "",
      },
      image3: {
        src: "https://via.placeholder.com/1000x1000.png?text=Klicke+zum+Bearbeiten",
        alt: "",
        info: "",
        link: "",
      },
      text1: "",
      text2: "",
      text3: "",
    };
    const type = "image_with_text_3";
    props.addContent({ key, type, value: imageWithText3 }, props.index);
  };
  const addVideo = () => {
    const video: Video = {
      src: "",
    };
    const type = "video";
    props.addContent({ key, type, value: video }, props.index);
  };
  const addButton = () => {
    const button: Button = {
      label: "",
      link: "",
    };
    const type = "button";

    props.addContent({ key, type, value: button }, props.index);
  };
  const addVideoWithText = () => {};
  const addTable = () => {
    const table: Table = {
      columns: [[""]],
      columnCount: 1,
    };
    const type = "table";
    props.addContent({ key, type, value: table }, props.index);
  };
  return (
    <Modal title="Komponente wählen" close={props.close}>
      <List>
        <ListItem onClick={addHeading}>Überschrift</ListItem>
        <ListItem onClick={addText}>Text</ListItem>
        <ListItem onClick={addImage}>Bild</ListItem>
        <ListItem onClick={addList}>Liste</ListItem>
        <ListItem onClick={addButton}>Button</ListItem>
        <ListItem onClick={addListLink}>Liste mit Links</ListItem>
        <ListItem onClick={addIconWithText}>Icon mit Text</ListItem>
        <ListItem onClick={addImageWithText}>Bild mit Text</ListItem>
        <ListItem onClick={addImageWithText2}>
          2 Spalten - Bild mit Text
        </ListItem>
        <ListItem onClick={addImageWithText3}>
          3 Spalten - Bild mit Text
        </ListItem>
        <ListItem onClick={addVideo}>Video</ListItem>
        <ListItem onClick={addVideoWithText}>Video mit Text</ListItem>
        <ListItem onClick={addTable}>Tabelle</ListItem>
      </List>
    </Modal>
  );
}
